import {fetch} from "../../../utils/dataAccess";

export function error(error) {
    return {type: "RETAILER_STRIPE_CREATE_ERROR", error};
}

export function loading(loading) {
    return {type: "RETAILER_STRIPE_CREATE_LOADING", loading};
}

export function success(created) {
    return {type: "RETAILER_STRIPE_CREATE_SUCCESS", created};
}

export function create(retailerId) {

    return dispatch => {
        dispatch(loading(true));

        const data = {
            retailer: retailerId,
        };

        return fetch("/retailer/stripe_invitation?retailer=" + retailerId, {method: "POST", body: JSON.stringify(data)})
            .then(response => {
                dispatch(loading(false));
                return response.json();
            })
            .then(retrieved => dispatch(success(retrieved)))
            .catch(e => {
                dispatch(loading(false));
                dispatch(error(e));
            });
    };
}

export function reset() {
    return dispatch => {
        dispatch({type: "RETAILER_STRIPE_CREATE_RESET"});
        dispatch(loading(false));
        dispatch(error(null));
    };
}
